const moment = window.moment;

export default function dateFilter(value, format) {
	if (value) {

		let momentString = '';

		switch(format){
			case 'short':
				momentString = 'l';
				break;
			case 'medium':
				momentString = 'll';
				break;
			case 'long':
				momentString = 'LL';
				break;
			case 'long_with_time':
				momentString = 'LLL';
				break;
			default:
				momentString = 'll';
		}

		return moment(value).format(momentString);
	}
}



// WEBPACK FOOTER //
// ./src/filters/date.js